import { ActionTypes } from "@/actions";
import { IComponent } from "@/definitions/componentDef";

export interface IComponentData {
    current: IComponent;
    updated?: IComponent;
    isNew?: boolean;
    backup?: IComponent;
}

const initialState: IComponentData = {
    current: {
        uid: '',
        name: '',
        slug: '',
        collection: '',
        fields: [],
        showGroups: false,
        public: 'private',
        dataSource: 'mongodb',
        mongoCollection: '',
        organization: '',
        menuFolder: '',
        menuIcon: '',
    }
}

const componentReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ActionTypes.EDIT_COMPONENT_START:
            console.log('🔧 EDIT_COMPONENT_START - Raw payload:', action.payload);
            console.log('🔧 EDIT_COMPONENT_START - Collection fields:', {
                dataSource: action.payload.dataSource,
                mongoCollection: action.payload.mongoCollection,
                collection: action.payload.collection
            });

            // Resolve collection name - avoid 'default_collection'
            // Preserve existing mongoCollection values - don't overwrite with empty strings
            let resolvedCollection = action.payload.collection;
            let mongoCollection = action.payload.mongoCollection;

            if (!resolvedCollection || resolvedCollection === 'default_collection') {
                resolvedCollection = mongoCollection || action.payload.slug || '';
            }

            const processedComponent = {
                ...action.payload,
                // Ensure required fields have default values
                collection: resolvedCollection,
                dataSource: action.payload.dataSource || 'mongodb',
                public: action.payload.public && action.payload.public.trim() !== '' ? action.payload.public : 'private',
                // Preserve existing values - only use empty string if truly undefined/null
                mongoCollection: mongoCollection !== undefined && mongoCollection !== null ? mongoCollection : '',
            };

            const mcLoad = String(processedComponent.mongoCollection || '').trim();
            const colLoad = String(processedComponent.collection || '').trim();
            const syncName =
                mcLoad && colLoad && mcLoad !== colLoad ? mcLoad : mcLoad || colLoad;
            if (syncName) {
                processedComponent.mongoCollection = syncName;
                processedComponent.collection = syncName;
            }

            console.log('🔧 EDIT_COMPONENT_START - Processed component:', {
                dataSource: processedComponent.dataSource,
                mongoCollection: processedComponent.mongoCollection,
                collection: processedComponent.collection
            });

            // Create a deep backup of the component config
            const backup = JSON.parse(JSON.stringify(processedComponent));

            return {
                ...state,
                isNew: false,
                current: processedComponent,
                backup: backup,
            };
        case ActionTypes.EDIT_COMPONENT_NEW:
            return {
                ...state,
                isNew: true,
                current: {
                    uid: '',
                    name: '',
                    slug: '',
                    collection: '',
                    fields: [],
                    showGroups: false,
                    public: 'private',
                    dataSource: action.payload.dataSource || 'mongodb',
                    mongoCollection: '',
                    organization: '',
                    menuFolder: '',
                    menuIcon: '',
                },
            };
        case ActionTypes.EDIT_COMPONENT_VALUE_UPDATED: {
            const key = action.payload.key;
            const raw = action.payload.value;
            console.log('🔄 EDIT_COMPONENT_VALUE_UPDATED:', {
                key,
                value: raw,
                currentState: state.current
            });

            let updatedComponent: IComponent = {
                ...state.current,
                [key]: raw,
            };

            if (key === 'collection' || key === 'mongoCollection') {
                const v = typeof raw === 'string' ? raw.trim() : raw;
                updatedComponent = {
                    ...updatedComponent,
                    collection: v as string,
                    mongoCollection: v as string,
                };
            }

            console.log('🔄 Updated component:', {
                dataSource: updatedComponent.dataSource,
                mongoCollection: updatedComponent.mongoCollection,
                collection: updatedComponent.collection
            });

            return {
                ...state,
                current: updatedComponent,
            };
        }
        case ActionTypes.EDIT_COMPONENT_FIELD_UPDATED:
            const nextValues = state.current.fields.map((field: any) => {
                if (field.uid !== action.payload.uid) {
                    return field;
                }
                return {
                    ...field,
                    [action.payload.name]: action.payload.value,
                };
            });
            return {
                ...state,
                current: {
                    ...state.current,
                    fields: nextValues,
                },
            };

        case ActionTypes.EDIT_COMPONENT_FIELD_DELETE:
            let values = state.current.fields.filter((field: any) => field.uid !== action.payload.uid)

            return {
                ...state,
                current: {
                    ...state.current,
                    fields: values,
                },
            };

        case ActionTypes.EDIT_COMPONENT_UPDATE_STATE:
            return {
                ...state,
                current: {
                    ...state.current,
                    fields: state.current.fields,
                },
            };

        case ActionTypes.EDIT_COMPONENT_FIELD_NEW:
            return {
                ...state,
                current: {
                    ...state.current,
                    fields: [
                        ...state.current.fields,
                        {
                            name: "",
                            label: "",
                            type: "text",
                            value: "",
                            uid: Math.random().toString(36).substring(7),
                        },
                    ],
                },
            }
        case ActionTypes.EDIT_COMPONENT_RESET:
            if (state.backup) {
                // Restore from backup
                const restoredComponent = JSON.parse(JSON.stringify(state.backup));
                return {
                    ...state,
                    current: restoredComponent,
                };
            }
            return state;
        case ActionTypes.LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export default componentReducer;